import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Admin } from 'app/models/admin';
import { AdminsService } from 'app/services/admins/admins.service';

@Component({
  selector: 'app-modifier-admins',
  templateUrl: './modifier-admins.component.html',
  styleUrls: ['./modifier-admins.component.scss']
})
export class ModifierAdminsComponent implements OnInit {
  hide = true;
  email = new FormControl('', [Validators.required, Validators.email]);
  adminData:Admin
  dataSource = new MatTableDataSource();
public idAdmin: any
  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  constructor(private adminService:AdminsService,
    private activatedRoute: ActivatedRoute) { 
    this.adminData = new Admin
  }
getData(){
  this.idAdmin= this.activatedRoute.snapshot.paramMap.get('id')
    
  this.adminService.getAdmin(this.idAdmin).subscribe(data => {
    console.log(data)
    this.adminData = data;

  })
}
  ngOnInit(): void {
    this.adminService.refreshNedeed.subscribe(() => this.getData());
    this.getData()
  }

  updateAdmins(){
    this.adminService.updateAdmin(this.adminData.id, this.adminData).subscribe((response: any) => {

      this.dataSource.data = this.dataSource.data.map((o: Admin) => {
        if (o.id === response.id) {
          o = response;
        }
        return o;
      })
      setTimeout(()=>{
        this.getData()
      },500)
    
    })
  }

}
